<template>
  <div class="connection-list">
    <c-flex-layout class="_header">
      <template #left>
        <h1>
          Your Notion workspaces
        </h1>
      </template>
      <template #right>
        <c-button
          color="primary"
          :loading="connectLoading"
          :to="{ name: routeNames.connectToNotion }"
        >
          Add connection
        </c-button>
      </template>
    </c-flex-layout>
    <c-card padding>
      <div
        v-if="workspaces.length === 0"
        :style="{ color: $colors.grey.base }"
      >
        No workspaces connected yet
      </div>
      <c-list distance="large">
        <workspace-item
          v-for="(workspace, index) in workspaces"
          :key="index"
          :workspace="workspace"
        />
      </c-list>
    </c-card>
  </div>
</template>

<script>
import CButton from 'shared/components/CButton.vue';
import CCard from 'shared/components/CCard.vue';
import CFlexLayout from 'shared/components/CFlexLayout.vue';
import CList from 'shared/components/CList.vue';
import WorkspaceItem from '@/components/WorkspaceItem.vue';
import routeNames from '@/router/routes';
import { USER_SERVICE } from 'shared/constants';
import { collection, onSnapshot, query } from 'shared/services/firebase';
import { inject } from 'vue';

export default {
  name: 'ConnectionList',
  components: { CCard, CButton, CFlexLayout, WorkspaceItem, CList },
  setup() {
    const userService = inject(USER_SERVICE);
    return { currentUser: userService.currentUser };
  },
  data() {
    return { workspaces: [], connectLoading: false, routeNames };
  },
  methods: {
    async getWorkspaces() {
      const q = query(collection(this.$db, 'users', this.currentUser.uid, 'workspaces'));
      const unsubscribe = onSnapshot(q, (querySnapshot) => {
        const workspaces = [];
        querySnapshot.forEach((doc) => {
          workspaces.push(doc.data());
        });
        this.workspaces = workspaces;
      });
      this.$subscriptionManager.addSubscriber(unsubscribe, { auth: true });
    },
  },
  created() {
    this.getWorkspaces();
  },
};

</script>

<style
    scoped
    lang="scss"
    type="text/scss"
>

</style>
